module.exports = "//public.zight.com/packs/media/images/icons-download-bordered-a1fa21535c5bbff76a6276876db4b88e.png";